import { createApp } from 'vue';
import axios from 'axios';

import Retailer from './vueComponents/Retailer.vue';
import RetailerMap from './vueComponents/RetailerMap.vue';
import RetailerSearchInput from "./vueComponents/RetailerSearchInput.vue";
import RetailerSearchGeoLocateUser from "./vueComponents/RetailerSearchGeoLocateUser.vue";

export default {
    name: "retailers",

    init() {
        const el = document.querySelector('#js_retailers');

        if (el) {
            this.run(el);
        }
    },

    run (el)
    {
         createApp({
            delimiters: ["@{", "}"],
            data() {
                return {
                    activeFilter : '',
                    currentRetailer : null,
                    highlightedRetailer : null,
                    results : [],
                    groupedRetailers : [],
                    xhrActive : false,
                    showFilters : true,
                    fallbackInAction: false,
                    lat: null,
                    lng: null,
                    geoString: '',
                    items : [],
                    municipalityQuery : '',
                    municipalities : [],
                    states : [],
                    query : '',
                    sortBy : 'name',
                    order : 'asc',
                    toggledMap : false,
                    selectedMunicipalities : [],
                    selectedStates : [],

                    view : 'map',
                }
            },

            components: {
                Retailer,
                RetailerMap,
                RetailerSearchInput,
                RetailerSearchGeoLocateUser
            },

            created: function()
            {
                // this.showFilters = (window.innerWidth < 1200) ? false : true;
                this.showFilters = (window.innerWidth >= 1200);
                this.getRetailers();
            },

            computed:
            {
                filteredItems()
                {
                   return this.results;
                },

                filteredMunicipalities()
                {
                    if (this.municipalityQuery.length === 0) {
                        return this.municipalities;
                    }

                    const query = this.municipalityQuery.toLowerCase();

                    return this.municipalities.filter((m) => m.toLowerCase().includes(query));
                },

                toggledMapCss()
                {
                    return (this.toggledMap) ? ' map-is-toggled ' : ' map-is-hidden ';
                },

                showFiltersCss()
                {
                    return '';
                },

            },

            methods :
            {
                _log(value) {
                    if (document.location.host === "gspartner.test") {
                        console.log(value);
                    }
                },

                applyQueryArgs() {
                    // this._log('applyQueryArgs()');
                    const params  = new URLSearchParams(window.location.search);

                    // query
                    const search  = params.get('query');
                    // remove white spaces from query
                    const query = search ? search.replace(/\s+/g,' ').trim() : '';

                    const municipality = params.get('municipality');
                    // const tags = params.get('tags');

                    // this.selectedCategories     = params.getAll('kategori[]');
                    this.selectedMunicipalities = municipality ? municipality.split(',') : [];
                    // this.selectedTags = tags ? tags.split(',') : [];

                    this.setQuery(query);
                },

                closeFilter(filter, e) {
                    this.activeFilter = '';
                },

                changeActiveFilter(filterName, e) {
                    this.activeFilter = (this.activeFilter !== filterName) ? filterName : '';
                },

                changeRetailer(retailerId, trigger) {
                    if (this.currentRetailer?.id !== retailerId) {
                        const result = this.items.filter((r) => r.id == retailerId);

                        const newRetailer = (typeof result[0] === 'object') ? result[0] : null;

                        if (trigger === 'list') {
                            this.currentRetailer = newRetailer;
                        }

                        this.highlightedRetailer = newRetailer;
                    }

                    // scroll to object only if event was triggerd by map
                    if (trigger === 'map') {
                        setTimeout(this.scrollToHighlightedRetailer, 1500);
                    }
                },

                calcDistance (lat1, lon1, lat2, lon2, unit) {
                    if ((lat1 == lat2) && (lon1 == lon2)) {
                        return 0;
                    }
                    else {
                        const radlat1 = Math.PI * lat1/180;
                        const radlat2 = Math.PI * lat2/180;
                        const theta = lon1-lon2;
                        const radtheta = Math.PI * theta/180;
                        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                        if (dist > 1) {
                            dist = 1;
                        }
                        dist = Math.acos(dist);
                        dist = dist * 180/Math.PI;
                        dist = dist * 60 * 1.1515;
                        if (unit==="K") { dist = dist * 1.609344 }
                        if (unit==="N") { dist = dist * 0.8684 }

                        return parseInt(dist);
                    }
                },

                isQueryZipcode(query) {
                    const zipcode = parseInt(query);
                    this._log(`isQueryZipcode(${zipcode})`);
                    this._log(Number.isInteger(zipcode));

                    return (query.length === 4 && Number.isInteger(zipcode) === true);
                },

                filterItems() {
                    let results = [];
                    this.currentRetailer = null;
                    const query = this.getQuery(true);
                    this._log(`🤡 filter Items(${query})`);

                    results = this.items;

                    // default search
                    if (! this.isQueryZipcode(query) && query.length >= 3) {
                        this._log(`default search`);
                        results = [];
                        this.items.forEach((item) => {
                            // requires a query of minimum 3 chars
                            let passedQuery = this.filterByQuery(item, query)
                            let passedMunicipalities = this.filterByMunicipality(item);
                            let passedStates = this.filterByState(item);

                            if (passedQuery && passedMunicipalities && passedStates) {
                                results.push(item);
                            }
                        });
                    }

                    this._log( `sort ${this.sortBy} | order: ${this.order}`);
                    if (this.sortBy === 'distance' && this.lat && this.lng) {
                        results.map((retailer) => {
                            retailer.distance = 0;
                            if (typeof retailer.position === 'object' && retailer.position !== null) {
                                retailer.distance = this.calcDistance(this.lat, this.lng, retailer.position.lat, retailer.position.lng, "K");
                            }

                            return retailer;
                        });

                        results.sort((a, b) => (a.distance > b.distance) ? 1 : -1)
                        // sort by name
                    } else if (this.sortBy === 'name' && this.order === 'asc') {
                        results.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
                    } else if (this.sortBy === 'name' && this.order === 'desc') {
                        results.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase()) ? 1 : -1)
                    }

                    this.results = results;
                },

                filterByMunicipality(item) {
                    return this.selectedMunicipalities.length === 0 || this.selectedMunicipalities.includes(item.municipality);
                },

                filterByState(item) {
                    return this.selectedStates.length === 0 || this.selectedStates.includes(item.regionName);
                },

                filterByQuery(item, query)  {
                    let passedQuery = true;

                    if (query.length >= 3) {
                        passedQuery = item.name.toLowerCase().includes(query)
                            || (item.city !== null && item.city.toLowerCase().includes(query))
                            || (item.zipcode !== null && item.zipcode.toLowerCase().includes(query))
                            || (item.municipality !== null && item.municipality.toLowerCase().includes(query))
                            || (item.regionName !== null && item.regionName.toLowerCase().includes(query));
                    }

                    return passedQuery;
                },

                getRetailers() {
                    this.rest('/actions/gs/retailer/index', [], 'getRetailers__callback');
                },

                getRetailers__callback(response){
                     if (typeof response.data === 'object') {
                         const showStats = new URLSearchParams(window.location.search).has('stats');

                        if (showStats) {
                            const totaltItems = response.data.length;
                            const enabledItems = response.data.filter((i) => i.skyspanner == '1').length;
                            console.info(`Total ${totaltItems}`);
                            console.info(`Enabled ${enabledItems}`);
                        }

                        // exclude all with empty position
                        this.items = response.data.filter((i) => (i.position.lat != 0 && i.position.lng != 0));
                    }

                    this.setupFilters();
                    this.applyQueryArgs();
                    this.groupRetailerByState();
                    this.filterItems();
                },

                groupRetailerByState()
                {
                    // console.log('group retailes by state');
                    // console.log(this.states);
                    this.groupedRetailers = [];

                    this.states.forEach((state) => {
                        // console.log(state);
                        let row = {
                            'label' : state,
                            'items' : []
                        };

                        this.items.forEach((item) => {
                            if (item.regionName === state) {
                                row.items.push(item);
                            }
                        });

                        this.groupedRetailers.push(row);
                    });
                },

                isActiveTab(type)
                {
                    return this.view === type ? ' active ' : '';
                },

                isActiveFilter(filterName)
                {
                    return (filterName === this.activeFilter);
                },

                rest(endpoint, queryArgs, callback)
                {
                    let queryString = "";
                    for (let i in queryArgs) {
                        queryString += i + "=" + queryArgs[i]+"&";
                    }
                    const url = endpoint + "?" + queryString;

                    axios.get(url)
                        .then(this[callback])
                        .catch(function (error) {});
                },

                scrollToHighlightedRetailer()
                {
                    if (! this.highlightedRetailer) {
                        console.info('no current retailer');
                        return false;
                    }

                    // scroll to top of list
                    document.querySelector('.retailer-map__col--list')
                    .scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });

                    // console.info('scroll to '+this.currentRetailer.id+ ' '+this.currentRetailer.name);
                    // scroll to retailer
                    const element = document.getElementById("retailer-"+this.highlightedRetailer.id);
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
                    }
                },

                setSortAttributes(attr, order)
                {
                    this.setSortBy(attr);
                    this.setOrder(order);

                    if (this.sortBy === 'distance' && this.geoString.length === 0) {
                        this.getUsersGeoPosition();
                    }
                },

                setupFilters()
                {
                    const municipalities = new Set();
                    const states = new Set();

                    // const nameAttr = 'name'; // 'name_en' for english
                    this.items.forEach((p) => {
                        if (p.municipality !== null && p.municipality.trim()) {
                            municipalities.add(p.municipality);
                        }

                        if (p.regionName !== null && p.regionName.trim()) {
                            states.add(p.regionName);
                        }

                        // this.tags = tags;
                        this.states  = [...states].sort();
                        this.municipalities  = [...municipalities].sort();
                    });
                },

                toggleFilters()
                {
                    this.showFilters = ! this.showFilters;
                },

                unsetRetailer()
                {
                    this.currentRetailer = null;
                },

                updateQueryString()
                {
                    let queryParams = `?`;

                    const params = new URLSearchParams({
                        query: this.getQuery(),
                        municipality: this.selectedMunicipalities,
                        // tags: this.selectedTags,
                    });

                    const origin   = window.location.origin;
                    const pathname = window.location.pathname;
                    let url = origin + pathname + '?' + params.toString();

                    history.replaceState({}, null, url);
                },

                setupPosition(lat, lng, resetQuery=false) {
                    this._log(`🫡 setupPosition(${lat} - ${lng})`);

                    this.lat = parseFloat(lat).toFixed(2);
                    this.lng = parseFloat(lng).toFixed(2);
                    this.geoString = this.lat+','+this.lng;

                    this.setSortBy('distance');
                    this.setOrder('asc');

                    // force reset when user uses retailer-search-geo-locate
                    if (resetQuery) {
                        this.setQuery('');
                    }

                    this.filterItems();
                },

                updatedQuery(value) {
                    this.setQuery(value);
                    this.filterItems();
                },

                setQuery(value) {
                    this._log(`setQuery(${value})`);
                    this.query = value;
                },

                getQuery(forSearch=false) {
                    return (forSearch===false) ? this.query : this.query.trim().toLowerCase();
                },

                setOrder(value) {
                    this._log(`setOrder(${value})`);
                    this.order = value;
                },

                setSortBy(value) {
                    this._log(`setSortBy(${value})`);
                    this.sortBy = value;
                },

                setView(type) {
                    this.view = type;
                },

                toggleMap() {
                    const order = this.order;
                    // workaround to trigger RetailerMap.vue watch filteredRetailers
                    this.order = this.order === 'asc' ? 'desc' : 'asc';
                    this.order = order;

                    this.toggledMap = ! this.toggledMap;
                }
            }

        }).mount('#js_retailers'); // end of vue

    },

};
